import CirgsReportsList from './CirgsReportsList';

export default CirgsReportsList;
